module.exports = __webpack_public_path__ + "static/media/26.53bc4f51.png";